__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "json_view_0_1_3";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@kne/current-lib_json-view", "0.1.3", () => (Promise.all([__webpack_require__.e(646), __webpack_require__.e(922), __webpack_require__.e(404)]).then(() => (() => (__webpack_require__(43404))))));
			register("@kne/global-context", "1.3.2", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(628)]).then(() => (() => (__webpack_require__(20628))))));
			register("@kne/global-context", "1.3.2", () => (Promise.all([__webpack_require__.e(922), __webpack_require__.e(638)]).then(() => (() => (__webpack_require__(39638))))));
			register("@kne/react-fetch", "1.5.7", () => (Promise.all([__webpack_require__.e(426), __webpack_require__.e(201), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(3201))))));
			register("@kne/react-fetch", "1.5.7", () => (Promise.all([__webpack_require__.e(355), __webpack_require__.e(922)]).then(() => (() => (__webpack_require__(41355))))));
			register("@kne/react-intl", "0.1.15", () => (Promise.all([__webpack_require__.e(308), __webpack_require__.e(884), __webpack_require__.e(558), __webpack_require__.e(694)]).then(() => (() => (__webpack_require__(7308))))));
			register("@kne/react-intl", "0.1.15", () => (Promise.all([__webpack_require__.e(548), __webpack_require__.e(922), __webpack_require__.e(97)]).then(() => (() => (__webpack_require__(99548))))));
			register("@kne/remote-loader", "1.4.6", () => (Promise.all([__webpack_require__.e(426), __webpack_require__.e(884), __webpack_require__.e(467)]).then(() => (() => (__webpack_require__(31467))))));
			register("@kne/responsive-utils", "0.1.15", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(953)]).then(() => (() => (__webpack_require__(93953))))));
			register("antd", "6.5.3", () => (Promise.all([__webpack_require__.e(398), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(469), __webpack_require__.e(179)]).then(() => (() => (__webpack_require__(43398))))));
			register("axios", "1.19.0", () => (Promise.all([__webpack_require__.e(405), __webpack_require__.e(114)]).then(() => (() => (__webpack_require__(99405))))));
			register("dayjs", "1.11.21", () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(60446))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(97950))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(544)]).then(() => (() => (__webpack_require__(53245))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(65043))))));
			register("react", "18.3.1", () => (__webpack_require__.e(233).then(() => (() => (__webpack_require__(98233))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};